var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_list",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 3.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    id: "list"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,2 C2.54590571,2 2.99255584,1.55255682 2.99255584,1.015625 C2.99255584,0.45880682 2.54590571,0.02130682 2,0.02130682 L0.98263027,-3.47277762e-13 C0.43672457,-3.47277762e-13 1.59872116e-14,0.4375 1.59872116e-14,0.99431818 C1.59872116e-14,1.53125 0.43672457,1.97869318 0.98263027,1.97869318 L2,2 Z M13.0074442,1.984375 C13.5533499,1.984375 14,1.53693182 14,1 C14,0.44318182 13.5533499,0.00568182 13.0074442,0.00568182 L5.98263027,-5.99520433e-14 C5.43672457,-5.99520433e-14 5,0.4375 5,0.99431818 C5,1.53125 5.43672457,1.97869318 5.98263027,1.97869318 L13.0074442,1.984375 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_list-copy",
    transform: "translate(1.000000, 7.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,2 C2.54590571,2 2.99255584,1.55255682 2.99255584,1.015625 C2.99255584,0.45880682 2.54590571,0.02130682 2,0.02130682 L0.98263027,-3.47277762e-13 C0.43672457,-3.47277762e-13 1.59872116e-14,0.4375 1.59872116e-14,0.99431818 C1.59872116e-14,1.53125 0.43672457,1.97869318 0.98263027,1.97869318 L2,2 Z M13.0074442,1.984375 C13.5533499,1.984375 14,1.53693182 14,1 C14,0.44318182 13.5533499,0.00568182 13.0074442,0.00568182 L5.98263027,-5.99520433e-14 C5.43672457,-5.99520433e-14 5,0.4375 5,0.99431818 C5,1.53125 5.43672457,1.97869318 5.98263027,1.97869318 L13.0074442,1.984375 Z",
    id: "list"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_list-copy-2",
    transform: "translate(1.000000, 11.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,2 C2.54590571,2 2.99255584,1.55255682 2.99255584,1.015625 C2.99255584,0.45880682 2.54590571,0.02130682 2,0.02130682 L0.98263027,-3.47277762e-13 C0.43672457,-3.47277762e-13 1.59872116e-14,0.4375 1.59872116e-14,0.99431818 C1.59872116e-14,1.53125 0.43672457,1.97869318 0.98263027,1.97869318 L2,2 Z M13.0074442,1.984375 C13.5533499,1.984375 14,1.53693182 14,1 C14,0.44318182 13.5533499,0.00568182 13.0074442,0.00568182 L5.98263027,-5.99520433e-14 C5.43672457,-5.99520433e-14 5,0.4375 5,0.99431818 C5,1.53125 5.43672457,1.97869318 5.98263027,1.97869318 L13.0074442,1.984375 Z",
    id: "list"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon_list.d575ea140c6c087724ab33ba3f0c2a98.svg";
export { ForwardRef as ReactComponent };